import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { merge, isEqual } from 'lodash';
import { withRouter } from 'react-router';

import utils from '../../../../../utils/utilities';
import xhr from '../../../../../utils/xhr';

import BarChart from './../../../../../reusable/Charts/BarChart/BarChart.jsx';
import LineChart from './../../../../../reusable/Charts/LineChart/LineChart.jsx';

import api from '../../Dashboard.api';

import {
    PESTLE_ORDER
} from './../../../../../constants';
import reduxStore from '../../../../../reduxStore';
import commonActions from '../../../../../api/Common.actions';

class PESTLEChartPod extends React.Component {

    constructor(props) {
        super(props);

        this.openArticlesOverlay = this.openArticlesOverlay.bind(this);

        this.initialChartData = {
            config: {
                bindto:  '#dashboard-pestle-risk-chart',
                data:    {
                    rows:    [],
                    order:   null,
                    onclick: this.openArticlesOverlay,
                    selection: {
                        enabled: true
                    },
                },
                tooltip: {
                    grouped: false
                },
                padding: {
                    bottom: 40,
                    top:    30,
                    right:  20
                },
                grid:    {y: {show: true}},
                axis:    {
                    x: {
                        tick: {
                            culling: false,
                            rotate:  -45
                        }
                    },
                    y: {
                        tick: {
                            values: [0, 20, 40, 60, 80, 100],
                            count:  6,
                            format: (value) => value + '%'
                        }
                    }
                }
            }
        };

        this.user = reduxStore.getState().user;

        this.state = {
            chartData: this.initialChartData,
            spinner: true,
            riskAngle: null,
            isBarChartVisible: this.user.preferences.dashboard.newsVolumePodGraphStyle === 'bar' || !this.user.appSettings.lineChartEnabled,
            isLineChartVisible: this.user.preferences.dashboard.newsVolumePodGraphStyle === 'line' && this.user.appSettings.lineChartEnabled
        };

        this.loadDashboard = this.loadDashboard.bind(this);
        this.getFilterMessageId = this.getFilterMessageId.bind(this);
        this.toggleChartView = this.toggleChartView.bind(this);
    }

    openArticlesOverlay(data) {
        let day = this.state.chartData.days[data.index],
            //TODO use day not unixDay timestamp
            unixDay = utils.convertDaysToMilliseconds(day),
            riskAngle = data.name.toLowerCase();

        let catFilter = utils.buildDashboardFilter(this.props.entities, this.props.risk, this.props.pestle, null, this.props.language);
        catFilter.day = day;

        this.props.router.push(`/news/${riskAngle}/${unixDay}/${JSON.stringify(catFilter)}`)
    }

    componentWillMount() {
        this.loadDashboard(this.props.days, this.props.entities, this.props.pestle, this.props.risk, this.props.language);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.days !== nextProps.days ||
            !isEqual(this.props.pestle, nextProps.pestle) ||
            !isEqual(this.props.entities, nextProps.entities) ||
            !isEqual(this.props.language, nextProps.language) ||
            !isEqual(this.props.risk, nextProps.risk)) {
            this.loadDashboard(nextProps.days, nextProps.entities, nextProps.pestle, nextProps.risk, nextProps.language);
        }
    }

    loadDashboard(days, entities, pestle, risk, language) {
        this.setState({chartData: this.initialChartData, spinner:true});
        let catFilter = utils.buildDashboardFilter(entities, risk, pestle, days, language);

        api.getAndParsePestleRiskData(catFilter)
            .then((chartData) => {
                let completeChartData = merge({
                    config: {
                        tooltip: {
                            format: {
                                value: (value, ratio, id, index) => {

                                    // Display the number of articles calculated from the original chart data
                                    let columnIndex = PESTLE_ORDER.indexOf(id.toLowerCase());

                                    let numberOfArticles = Math.round(
                                        chartData.rowTotals[index + 1] *
                                        (chartData.originalChartData[index + 1][columnIndex] / 100)
                                    );

                                    return this.props.intl.formatMessage({id: 'General_CoreFunctionality_UIText_general.'+id.toLowerCase()}) + ' | ' +
                                        numberOfArticles + ' ' +
                                        this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.articles'});
                                }
                            }
                        }
                    }
                }, this.state.chartData, chartData);

                this.setState({
                    chartData: completeChartData,
                    spinner:false
                });

            })
            .catch((error) => {
                utils.logError(error, 'DashboardPestleRiskChart.componentWillMount():');
                this.setState({spinner:false});
                xhr.handleAllErrors(error);
            });
    }

    getFilterMessageId () {
        switch (this.props.days.toString()) {
            case '1':
                return 'Dashboard_Charts_UIText_dashboard.chartPod.filter1Day';
            case '7':
                return 'Dashboard_Charts_UIText_dashboard.chartPod.filter7Days';
            default:
                return 'Dashboard_Charts_UIText_dashboard.chartPod.filter30Days';
        }
    };

    toggleChartView() {
        let prefs = this.user.preferences.dashboard;
        let updatedPrefs = Object.assign(prefs, {
            newsVolumePodGraphStyle: this.user.preferences.dashboard.newsVolumePodGraphStyle === 'bar' ? 'line' : 'bar'
        });
        commonActions.updateDashboardPrefs({...updatedPrefs});
        this.setState({
            isBarChartVisible:  !this.state.isBarChartVisible,
            isLineChartVisible: !this.state.isLineChartVisible
        })
    }

    render() {

            return (
                <div>
                    <div className="graph-title">
                        <span className='title'>
                            <FormattedMessage id={this.getFilterMessageId()} />
                        </span>

                        {
                            this.user.appSettings.lineChartEnabled ?
                                <span>
                                    <span className='toggle-text'>
                                        Switch Graph View
                                    </span> <span className='la-Update toggle-icon' onClick={this.toggleChartView} />
                                </span>
                                :
                                null
                        }

                    </div>

                    {
                        this.state.isLineChartVisible ?
                            <div className="graph-container line-chart">
                                {this.state.spinner ? <div className="temporary-loading-spinner" /> : null }
                                <LineChart days={this.props.days}
                                           category={this.props.category}
                                           entities={this.props.entities}
                                           pestle={this.props.pestle}
                                           risk={this.props.risk}
                                           language={this.props.language}
                                           openArticlesOverlay={this.openArticlesOverlay}
                                />
                            </div>
                            :
                            null
                    }

                    {
                        this.state.isBarChartVisible ?
                            <div className="graph-container bar-chart">
                                {this.state.spinner ? <div className="temporary-loading-spinner" /> : null }
                                <BarChart config={this.state.chartData.config} />
                            </div>
                            :
                            null
                    }

                </div>
            )
    }

}

export default withRouter(injectIntl(PESTLEChartPod));


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/PESTLEPod/PESTLEChartPod.jsx